import {useState,useEffect, useContext} from 'react'
import Container from '../../Components/Auth/Container'
import {Helmet} from "react-helmet";
import { GeneralFunctionsContext } from '../../Components/Contexts/GeneralFunctionsContext';

export default function Uploads () {
     const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    
    return (
        <>
        
        <Helmet>
            <title>Login/Register</title>
            <meta property="og:title" content="Login/Register" />
            <meta name="title" content="Login/Register" />
            <meta name="description" content="Login/Register on geniux music"/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png" />
        </Helmet>
         <Container innerWidth={innerWidth} /> 
            
        </>
    )
}


